import { LoadingRequestResponseType } from "../types/LoadingRequestResponseType";
import { LoadingRequestType } from "../types/LoadingRequestType";
import { API, handleErrorApi } from "./api";

const sendLoadingPostRequest = async <T, R>({
    loadingFunction,
    endpoint,
    params
}: LoadingRequestType<T>): Promise<LoadingRequestResponseType<R>> => {
    if (loadingFunction)
        loadingFunction(true);
    try {
        const response = await API.post<R>(endpoint, params);
        if (loadingFunction)
            loadingFunction(false);
        return {
            success: true,
            data: response
        }
    } catch (error: any) {
        if (error?.response?.status === 401) {
            window.location.reload();
        }
        if (loadingFunction)
            loadingFunction(false);
        const msg = handleErrorApi(error);
        return {
            success: false,
            error: msg
        }
    }
};

export {
    sendLoadingPostRequest
}